export default __webpack_public_path__ + "static/media/portfolio-docenti-nc.ffc187c8.svg";